module.exports = __webpack_public_path__ + "static/media/construct.b8997315.png";